exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host .logo-img {\n  float:left;\n  width: auto;\n  height:50px;\n  padding:5px;\n}\n\n:host .logo-img img{\n  height:40px;\n  width:auto;\n}\n\n:host #langChanger {\n  margin-top: 15px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/wiserisk-core/src/main/ng4app/src/app/components/navbar/navbar.component.css
// module id = ../../../../../src/app/components/navbar/navbar.component.css
// module chunks = main